import { useContext, useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import About from './pages/About';
import Dignitaries from './pages/Dignitaries';
import Gallery from './pages/Gallery';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/ContactUs';
import Footer from './components/Footer';
import ScrollToTop from './components/Scroller';
import toast from 'react-hot-toast';
import NotFound from './pages/NotFound';
import { schoolContext } from './contexts/SchoolContextProvider';
import { fetchGuestUserToken } from './services/authServices';
import { getFormEntriesByFormName } from './services/formServices';
import { FORMNAMES } from './utilities/codes';
import { loaderContext } from './contexts/LoaderProvider';
import Teachers from './pages/Teachers';
import TopStudents from './pages/TopStudents';
import NotProfileFound from './components/NotProfile';

function App() {
  const [guestToken, setGuestToken] = useState(false);
  const { schoolDetails, setSchoolDetails } = useContext(schoolContext);
  const { setIsLoading } = useContext(loaderContext);
  const [apiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    fetchGuestToken();
  }, []);

  const fetchGuestToken = async () => {
    try {
      const responseToken = await fetchGuestUserToken();
      if (responseToken) {
        setGuestToken(true);
        getSchoolDetail();
      }
      else toast.error("Session expired. Please refresh to continue")
    } catch (error) {
      toast.error(error?.message);
    }
  }

  const getSchoolDetail = async () => {
    try {
      setIsLoading(true);
      const resDetails = await getFormEntriesByFormName(FORMNAMES.SCHOOLPROFILE);
      const resSchoolInfo = resDetails[0]?.payload;
      if (resSchoolInfo) {
        setSchoolDetails(resSchoolInfo);
        if (resSchoolInfo?.logo?.fileUrl) localStorage.setItem("school_logo", resSchoolInfo?.logo?.fileUrl);
        saveThemeColor(resSchoolInfo)
      } else {
        toast.error("Error in getting School details")
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setApiLoaded(true);
    }
  }

  const saveThemeColor = (schoolInfo) => {
    const root = document.documentElement;
    if (schoolInfo?.primary) { root.style.setProperty('--color-primary', schoolInfo?.primary); }
    if (schoolInfo?.secondary) { root.style.setProperty('--color-secondary', schoolInfo?.secondary); }
    if (schoolInfo?.accent) { root.style.setProperty('--color-accent', schoolInfo?.accent); }
  }

  return (
    <>
      {!apiLoaded ? null : (
        guestToken && schoolDetails?.publish ? (
          <div className="font-sans text-gray-700">
            <ScrollToTop />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dignitaries" element={<Dignitaries />} />
              <Route path="/topteachers" element={<Teachers />} />
              <Route path="/topstudents" element={<TopStudents />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
        ) : (
          <NotProfileFound />
        )
      )}

    </>
  );
}

export default App;
